import { Flex } from "antd";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { CheckIcon, RowCell, StyledTableWrapper } from "./Styled";

interface ProgressiveStep {
    from: number;
    coefficient: number;
}

interface ProgressiveScaleProps {
    currentPercent: number;
    progressive: ProgressiveStep[];
}

interface DataRecord {
    key: number;
    percent: string;
    coefficient: string;
    completed: boolean;
}

const columns: ColumnsType<DataRecord> = [
    {
        title: "Відсоток виконання плану",
        dataIndex: "percent",
        key: "percent",
        children: [
            {
                dataIndex: "completed",
                key: "completed",
                width: 68,
                render: (_, record: DataRecord) => (
                    <RowCell>
                        <CheckIcon $active={record.completed} />
                    </RowCell>
                ),
            },
            {
                dataIndex: "percent",
                key: "percent-text",
                render: (_, record: DataRecord) => (
                    <RowCell>{record.percent}</RowCell>
                ),
            },
        ],
        render: (_, record: DataRecord) => (
            <RowCell>
                <CheckIcon $active={record.completed} />
                {record.percent}
            </RowCell>
        ),
    },
    {
        title: "Коефіцієнт",
        dataIndex: "coefficient",
        key: "coefficient",
        render: (_, record: DataRecord) => (
            <RowCell>{record.coefficient}</RowCell>
        ),
    },
];

export const ProgressiveScale: FC<ProgressiveScaleProps> = ({
    currentPercent,
    progressive,
}) => {
    const data: DataRecord[] = progressive.map((item, index) => ({
        key: index,
        percent: `${item.from}%`,
        coefficient: item.coefficient.toString(),
        completed: item.from <= currentPercent,
    }));

    return (
        <Flex vertical gap={24}>
            <PrimaryText fontSize={14} fontWeight="400" lineHeight="140%">
                Прогресивна шкала — це система нарахування бонусів, в якій
                коефіцієнт зростання збільшується при досягненні наступного
                кроку відсотку виконання плану.
            </PrimaryText>

            <StyledTableWrapper>
                <Table
                    columns={columns}
                    bordered
                    dataSource={data}
                    pagination={false}
                    rowKey="key"
                />
            </StyledTableWrapper>
        </Flex>
    );
};
